var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m57 34.53v-19.61c3.387-.488 6-3.401 6-6.92 0-3.859-3.14-7-7-7s-7 3.141-7 7h-48v40h30.051c.52 8.356 7.465 15 15.949 15 8.822 0 16-7.178 16-16 0-5.039-2.347-9.535-6-12.47zm-1-31.53c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5zm-53 7h46.295c.239.798.619 1.533 1.107 2.185l-6.116 6.116c-.392-.188-.824-.301-1.286-.301s-.894.113-1.285.301l-2.015-2.015c.187-.392.3-.824.3-1.286 0-1.654-1.346-3-3-3s-3 1.346-3 3c0 .462.113.894.301 1.285l-5.015 5.015c-.392-.187-.824-.3-1.286-.3-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3c0-.462-.113-.894-.301-1.285l5.015-5.015c.392.187.824.3 1.286.3s.894-.113 1.285-.301l2.015 2.015c-.187.392-.3.824-.3 1.286 0 1.654 1.346 3 3 3s3-1.346 3-3c0-.462-.113-.894-.301-1.285l6.117-6.116c.915.686 2.001 1.151 3.184 1.322v18.245c-2.357-1.369-5.084-2.166-8-2.166-4.78 0-9.066 2.118-12 5.453v-4.453h-6v12h2.292c-.124.653-.199 1.322-.241 2h-28.051zm40 10c.551 0 1 .448 1 1s-.449 1-1 1-1-.448-1-1 .449-1 1-1zm-7-5c0-.552.449-1 1-1s1 .448 1 1-.449 1-1 1-1-.448-1-1zm-7 9c0 .552-.449 1-1 1s-1-.448-1-1 .449-1 1-1 1 .448 1 1zm18 31c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm-14-15.729c-.479.864-.875 1.777-1.189 2.729h-.811v-8h2zm13-6.22v4c-5.046.504-9 4.773-9 9.949 0 1.463.324 2.85.891 4.104l-3.469 2.003c-.902-1.848-1.422-3.916-1.422-6.107 0-7.382 5.747-13.433 13-13.949zm1 27.949c-4.814 0-9.068-2.443-11.588-6.155l3.483-2.011c1.818 2.518 4.769 4.166 8.105 4.166s6.287-1.648 8.105-4.166l3.483 2.011c-2.52 3.712-6.774 6.155-11.588 6.155zm12.578-7.893-3.469-2.003c.567-1.254.891-2.641.891-4.104 0-5.176-3.954-9.446-9-9.949v-4c7.253.516 13 6.567 13 13.949 0 2.191-.52 4.259-1.422 6.107z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 41c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm0 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 12h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 12h14v2h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 16h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 16h14v2h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 20h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 20h14v2h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 24h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 24h14v2h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 44h6v-10h-6zm2-8h2v6h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 44h6v-8h-6zm2-6h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 44h6v-16h-6zm2-14h2v12h-2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f6bbe19cb2c5ed7975c32f4e5d604c89.svg";
export { ForwardRef as ReactComponent };